'use client';
import * as React from 'react';
import { Button } from '@/core/ui/primitives/button';
import { LuMoon, LuSun } from 'react-icons/lu';

export const ThemeToggle: React.FC<React.HTMLAttributes<HTMLButtonElement>> = ({ className, ...props }) => {
  const [isDark, setIsDark] = React.useState(false);
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedTheme = localStorage.getItem('theme');
      const dark = storedTheme === 'dark';
      setIsDark(dark);
      document.documentElement.classList.toggle('dark', dark);
    }
  }, []);
  const toggleTheme = () => {
    if (typeof window !== 'undefined') {
      const newIsDark = !isDark;
      setIsDark(newIsDark);
      setTimeout(() => {
        document.documentElement.classList.toggle('dark', newIsDark);
        localStorage.setItem('theme', newIsDark ? 'dark' : 'light');
      }, 150);
    }
  };
  return (
    <Button
      type='button'
      variant='ghost'
      size='icon'
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={toggleTheme}
      className={className}
      style={{ WebkitTapHighlightColor: 'transparent' }}
      {...props}>
      {isDark ? <LuMoon className='h-4 w-4' /> : <LuSun className='h-4 w-4' />}
    </Button>
  );
};
